export default (string) => {
  if (string === 'false') {
    return false;
  } if (string === 'true') {
    return true;
  }
  return undefined;
};
